import "./baseConfig/font.css.ts.vanilla.mjs";
import "./input.css.ts.vanilla.mjs";
var t = "p273__input-1348_fc7937b2e__11hypx60", e = "p273__input-1348_fc7937b2e__11hypx61";
export {
  t as inputStyle,
  e as measureInputStyle
};
//# sourceMappingURL=input.mjs.map
